export const triggerChartRedraw = (): void => {
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 100)
}

export * from './react-utils'
